/**
 * Created by tigran on 19.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

type ArrowRightIconProps = IconType & {
  variant?: 'default' | 'date';
};

export const ArrowRightIcon: FC<ArrowRightIconProps> = (props) => {
  const { width, height, color, style, variant = 'default' } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };

  if (variant === 'date') {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}
      >
        <g id="Shopicon">
          <g>
            <polygon points="17.415,41.414 14.587,38.586 29.173,24 14.587,9.414 17.415,6.586 34.829,24" />
          </g>
        </g>
      </svg>
    );
  }

  return (
    <svg
      width={width}
      height={height}
      style={style}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66669 13.2415L5.73942 14.3142L11.7394 8.31421L5.73942 2.31421L4.66669 3.38694L9.59393 8.31421L4.66669 13.2415Z"
        fill={color}
      />
    </svg>
  );
};
